// Pure helpers over the Post-Acquisitions Channel/RequestType/Stage taxonomy.
// The taxonomy is served by the backend via /api/appSetting (see
// AppSettingController.GetAppSettings on the server, mirrored to
// PostAcquisitionRequestTypeLookup). Callers pass the entries array in.

export const getChannels = entries =>
  [...new Set(entries.map(e => e.channel))];

export const getRequestTypesForChannel = (entries, channel) =>
  entries.filter(e => e.channel === channel).map(e => e.requestType);

export const getStage = (entries, channel, requestType) =>
  entries.find(e => e.channel === channel && e.requestType === requestType)?.stage ?? null;

export const getRequiredProformaInputs = (entries, channel, requestType) =>
  entries.find(e => e.channel === channel && e.requestType === requestType)?.requiredProformaInputs ?? null;

// Returns true if saving an underwrite for this pair requires the Underwrite Manager
// role. False for unknown pairs.
export const getRequiresUnderwriteManager = (entries, channel, requestType) =>
  entries.find(e => e.channel === channel && e.requestType === requestType)?.requiresUnderwriteManager ?? false;
